import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortArrayByParameter'
})
export class SortArrayByParameterPipe implements PipeTransform {

  transform(array: any[], sort: { sortBy: `alphabetical`, parameter: string } | undefined): any[] {
    if (sort !== undefined) {
      return array.sort((a, b) => {
        if (sort.sortBy === `alphabetical`) {
          const aProperty = a[sort.parameter]
          const bProperty = b[sort.parameter]
          if (typeof aProperty === `string` && typeof bProperty === `string`) {
            return aProperty.localeCompare(bProperty, undefined, { sensitivity: 'base' });
          }
        }
        return 0;
      })
    }
    return array;
  }

}
